import {resolveChartEntityImageUrl} from '../../../utils/entityAvatarUrl';

function normalizeEntityRef(ref) {
    if (ref == null) {
        return '';
    }
    const trimmed = String(ref).trim();
    if (/^q\d+$/i.test(trimmed)) {
        return trimmed.toUpperCase();
    }
    return trimmed;
}

function pickSourceImage(ref, source) {
    if (!source || !ref) {
        return '';
    }
    const normalized = normalizeEntityRef(ref);
    const matches = (value) => normalizeEntityRef(value) === normalized;
    if (matches(source.entityRef) || matches(source.ref)) {
        return source.imageUrl || source.image || '';
    }
    if (matches(source.fromEntityRef) || matches(source.from)) {
        return source.fromImageUrl || source.fromImage || '';
    }
    if (matches(source.toEntityRef) || matches(source.to)) {
        return source.toImageUrl || source.toImage || '';
    }
    return '';
}

/**
 * Resolve an entity picture for mutation/markup preview rows.
 * Prefers explicit mutation/op images, then on-chart canvas images, then KB avatar proxy URLs.
 *
 * @param {string|null|undefined} ref
 * @param {Array<object>|null|undefined} chartEntities
 * @param {object|null|undefined} [source]
 * @returns {string}
 */
export function resolvePreviewEntityImage(ref, chartEntities = [], source = null) {
    const fromSource = pickSourceImage(ref, source);
    if (fromSource) {
        return fromSource;
    }

    const normalized = normalizeEntityRef(ref);
    if (!normalized) {
        return '';
    }

    const match = (chartEntities || []).find((entity) => {
        const entityRef = normalizeEntityRef(entity?.wikidataId || entity?.id || entity?.entityRef);
        return entityRef === normalized;
    });
    const fromChart = match?.imageUrl || match?.image || '';
    return resolveChartEntityImageUrl({
        wikidataId: normalized,
        imageUrl: fromChart,
    });
}
